/** Red "HK" chip plus the italic dedicated-accountant line. */
export function HkAccountantNote() {
  return (
    <div className="flex items-center gap-[10px] py-2">
      <span className="rounded bg-[#EF4444] px-1.5 py-0.5 font-inter text-[10px] font-extrabold text-[#F3F4F6]">
        HK
      </span>
      <span className="font-suisse-intl-medium text-base italic leading-snug text-white sm:text-lg sm:leading-[28.8px]">
        Handled by a dedicated HK accountant
      </span>
    </div>
  );
}
